<template>
  <div class="brandmark">
    <v-head></v-head>
    <div class="brandmark_content">
      <div class="brandmark_content_one">
        <img src="../../../static/images/broadcast_banner.jpg" alt="">
      </div>
      {{{brandmark}}}
      <!--<div class="brandmark_content_two">
        <div class="brandmark_content_pulic">
          <div class="brandmark_content_two_two">
            <div>
              <p class="brandmark_content_two_tre"><a v-link="{path:'/slide'}">NAERSI 2016ss | 新 • 视觉——In Italy</a></p>
              <p class="brandmark_content_two_four">NAERSI 2016春夏以米兰为时尚视野，从新（心）出发，回到内心深处，找到最初的感动，演绎出全新视觉的意大利式风情。</p>
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <v-footer></v-footer>
  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
        brandmark:""
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;

      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/276",
        data: {},
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222, data)
            _this.brandmark = data.content;
          }
        },
      })
    }
  }
</script>

<style>
  .brandmark{width: 9rem;margin: 0 auto;}
  .brandmark_content>div + div{margin-bottom: 0.4rem}
  .brandmark_content>div img{width: 100%;height:100%}
  .brandmark_content>div:first-child{width: 9rem;height:auto }
  .brandmark_content>div:not(:first-child){width: 9rem;height: 4rem}
  /*.brandmark_content_one{background: url("../../../static/images/broadcast_banner.jpg") no-repeat center/cover;background-size: 9rem 2.4rem;}*/
  .brandmark_content_two{background: url(../../../static/images/brandmark.jpg) no-repeat center/cover;position: relative}
  .brandmark_content_pulic{border: 0.02rem solid #ffffff;width: 8rem;height: 3.6rem;margin: 0 auto;position: absolute;top:calc(50% - 1.8rem);left: calc(50% - 4rem)}
  .brandmark_content_pulic p{color: #000000;font-size: 0.16rem;margin-top: 0.2rem}
  .brandmark_content_two_two{width: 7.5rem;height: 3.2rem;background-color: #ffffff;opacity: 0.8;position: absolute;top:calc(50% - 1.6rem);left: calc(50% - 3.75rem)}
  .brandmark_content_two_two div{width: 6rem;height: 1.8rem;margin: 0 auto;position: absolute;top: calc(50% - 0.9rem);left: calc(50% - 3rem)}
  .brandmark_content_two_tre{border-bottom: 0.01rem solid #000000;width: 6rem;text-align: center;margin: 0 auto;padding-bottom: 0.2rem}
  .brandmark_content_two_four{font-size: 0.12rem;}
  .brandmark_content_two_two>div p a{font-size: 0.25rem;color: #000000}
  @media screen and (max-width: 30em) and (min-width:20em ){
    .brandmark_content img{width: 100% !important}
    .brandmark{overflow: hidden;width: 100%}
    .brandmark_content{margin-top: 0.5rem}
    .brandmark_content>div + div{margin-bottom: 0.4rem}
    .brandmark_content>div img{width: 100%;height:100%}
    .brandmark_content>div:first-child{width: 100%;height: auto}
    .brandmark_content>div:not(:first-child){width: 100%;height: 2rem}
    /*.brandmark_content_one{background: url("../../../static/images/broadcast_banner.jpg") no-repeat center/cover;background-size: 100% 100%;}*/
    .brandmark_content_two{background: url(../../../static/images/broadcast_3.jpg) no-repeat center/cover;position: relative;background-size: 100% 100%;}
    .brandmark_content_pulic{border: 0.02rem solid #ffffff;width: 80%;height: 1.8rem;margin: 0 auto;position: absolute;top:calc(50% - 0.9rem);left: calc(50% - 40%)}
    .brandmark_content_pulic p{color: #000000;font-size: 0.12rem;margin-top: 0.05rem;}
    .brandmark_content_two_two{width: 90%;height: 1.6rem;background-color: #ffffff;opacity: 0.8;position: absolute;top:calc(50% - 0.8rem);left: calc(50% - 45%);overflow: hidden}
    .brandmark_content_two_two div{width: 95%;height: 0.9rem;margin: 0 auto;position: absolute;top: calc(50% - 0.45rem);left: calc(50% - 47.5%)}
    .brandmark_content_two_tre{border-bottom: 0.01rem solid #000000;width: 100%;text-align: center;margin: 0 auto;padding-bottom: 0.2rem}
    .brandmark_content_two_four{font-size: 0.12rem;}
    .brandmark_content_two_two>div p a{font-size: 0.15rem;color: #000000}
  }
</style>



// WEBPACK FOOTER //
// brandmark.vue?248d5c94